/* GENERATED by scripts/sync-foundry-launcher.mjs. Do not edit.

   Foundry's exact class names, so the vendored stylesheet applies by
   construction. A part named here is a part Foundry ships; anything else is
   ours and belongs in the app's own stylesheet.

   A key spelled "part@hash" means that part name exists in more than one of
   the namespace's CSS modules and there is no unambiguous answer — pick the
   module the element belongs to. See the script header. */

/*
  app-display-components — 3 CSS module(s):
    15epo3b   tag-right, wrapper-row
    4b96ku    blueprint-app-icon
    1cwlrgz   tag-wrapper
*/
export const appDisplayComponents = {
  "blueprint-app-icon": "app-display-components__blueprint-app-icon__4b96ku",
  "tag-right": "app-display-components__tag-right__15epo3b",
  "tag-wrapper": "app-display-components__tag-wrapper__1cwlrgz",
  "wrapper-row": "app-display-components__wrapper-row__15epo3b",
} as const;

/*
  application-portal-promotion-components — 3 CSS module(s):
    2w7a4     favorite-icon, favorited
    19xuiid   image-failed, thumbnail-container
    1jg7jod   ws-blueprint-app-icon
*/
export const applicationPortalPromotionComponents = {
  "favorite-icon": "application-portal-promotion-components__favorite-icon__2w7a4",
  "favorited": "application-portal-promotion-components__favorited__2w7a4",
  "image-failed": "application-portal-promotion-components__image-failed__19xuiid",
  "thumbnail-container": "application-portal-promotion-components__thumbnail-container__19xuiid",
  "ws-blueprint-app-icon": "application-portal-promotion-components__ws-blueprint-app-icon__1jg7jod",
} as const;

/*
  application-portal-dialog — 9 CSS module(s):
    1bw4eg0   app-icon, buttons, container, description, edit-button, fav-icon, icon, is-favoriting, is-selected, thumbnail, title, title-and-description, title-and-icon-container
    1d3zmg1   add-button, apps-content, dialog-header, left-side, modal-apps, right-side
    3wj5e8    action-button, header, input, input-group, search-bar
    imsy1h    background-on-hover, menu-label, navigation-item, selected
    19o8r2n   details-panel, result-section, result-section-container
    1kxq4k1   divider, heading, list
    12czwt    divider, heading, list
    1iafdj1   header, header-container, navigation
    1qiq4rq   -clickable, internal-link
*/
export const applicationPortalDialog = {
  "-clickable": "application-portal-dialog__-clickable__1qiq4rq",
  "action-button": "application-portal-dialog__action-button__3wj5e8",
  "add-button": "application-portal-dialog__add-button__1d3zmg1",
  "app-icon": "application-portal-dialog__app-icon__1bw4eg0",
  "apps-content": "application-portal-dialog__apps-content__1d3zmg1",
  "background-on-hover": "application-portal-dialog__background-on-hover__imsy1h",
  "buttons": "application-portal-dialog__buttons__1bw4eg0",
  "container": "application-portal-dialog__container__1bw4eg0",
  "description": "application-portal-dialog__description__1bw4eg0",
  "details-panel": "application-portal-dialog__details-panel__19o8r2n",
  "dialog-header": "application-portal-dialog__dialog-header__1d3zmg1",
  "divider@12czwt": "application-portal-dialog__divider__12czwt",
  "divider@1kxq4k1": "application-portal-dialog__divider__1kxq4k1",
  "edit-button": "application-portal-dialog__edit-button__1bw4eg0",
  "fav-icon": "application-portal-dialog__fav-icon__1bw4eg0",
  "header-container": "application-portal-dialog__header-container__1iafdj1",
  "header@1iafdj1": "application-portal-dialog__header__1iafdj1",
  "header@3wj5e8": "application-portal-dialog__header__3wj5e8",
  "heading@12czwt": "application-portal-dialog__heading__12czwt",
  "heading@1kxq4k1": "application-portal-dialog__heading__1kxq4k1",
  "icon": "application-portal-dialog__icon__1bw4eg0",
  "input": "application-portal-dialog__input__3wj5e8",
  "input-group": "application-portal-dialog__input-group__3wj5e8",
  "internal-link": "application-portal-dialog__internal-link__1qiq4rq",
  "is-favoriting": "application-portal-dialog__is-favoriting__1bw4eg0",
  "is-selected": "application-portal-dialog__is-selected__1bw4eg0",
  "left-side": "application-portal-dialog__left-side__1d3zmg1",
  "list@12czwt": "application-portal-dialog__list__12czwt",
  "list@1kxq4k1": "application-portal-dialog__list__1kxq4k1",
  "menu-label": "application-portal-dialog__menu-label__imsy1h",
  "modal-apps": "application-portal-dialog__modal-apps__1d3zmg1",
  "navigation": "application-portal-dialog__navigation__1iafdj1",
  "navigation-item": "application-portal-dialog__navigation-item__imsy1h",
  "result-section": "application-portal-dialog__result-section__19o8r2n",
  "result-section-container": "application-portal-dialog__result-section-container__19o8r2n",
  "right-side": "application-portal-dialog__right-side__1d3zmg1",
  "search-bar": "application-portal-dialog__search-bar__3wj5e8",
  "selected": "application-portal-dialog__selected__imsy1h",
  "thumbnail": "application-portal-dialog__thumbnail__1bw4eg0",
  "title": "application-portal-dialog__title__1bw4eg0",
  "title-and-description": "application-portal-dialog__title-and-description__1bw4eg0",
  "title-and-icon-container": "application-portal-dialog__title-and-icon-container__1bw4eg0",
} as const;

